import { getAttachmentsFilterState } from '../utils';

export const selectSelectedRecordId = (state) => {
  return getAttachmentsFilterState(state).selectedRecordId;
};

export const selectSelectedDocType = (state) => {
  return getAttachmentsFilterState(state).selectedDocType;
};

export const selectSearch = (state) => {
  return getAttachmentsFilterState(state).search;
};

export const createIsSelectedRecordSelector = (recordId) => (state) => {
  return selectSelectedRecordId(state) === recordId;
};
